export default {
  methods: {
    converterFormatoHoraMinutoEmMinutos(horarioEmHoras) {
      var divisaoHorario = horarioEmHoras.split(":");
      return Number(divisaoHorario[0]) * 60 + Number(divisaoHorario[1]);
    },
    converterMinutosEmHora(valor) {
      var hora = Math.floor(valor / 60);
      var minutos = valor % 60;

      if (minutos < 10)
        minutos = "0" + minutos;

      if (hora < 10)
        hora = "0" + hora;

      return hora + ":" + minutos;
    },
    obterHorarioAtual() {
      const data = new Date();
      const hora = data.getHours();
      const minutos = data.getMinutes();

      const horarioAtual = (hora >= 10 ? hora : '0' + hora) + ':' + (minutos >= 10 ? minutos : '0' + minutos);
      return horarioAtual;
    },
    obterHorariosIndisponiveisDia(listaHorarios, toleranciaMinutos = null, disabled = true) {
      const horarioAtual = this.obterHorarioAtual();
      var toleranciaValor = toleranciaMinutos == null ? 15 : toleranciaMinutos;
      var horarioLimite = (this.converterFormatoHoraMinutoEmMinutos(horarioAtual) - toleranciaValor);

      for(var i = 0; i < listaHorarios.length; i++){
        var horarioDisponivel = this.converterFormatoHoraMinutoEmMinutos(listaHorarios[i].value);
        if (horarioDisponivel < horarioLimite)
          listaHorarios[i].disabled = disabled;
      }

      return listaHorarios;
    },
    converterMinutosParaFormatohhHmmMin(minutos) {
      var horas = Math.floor(minutos / 60);
      var minutosRestantes = minutos % 60;

      // Formatação para garantir que horas e minutos sejam exibidos com dois dígitos
      var horasFormatadas = horas < 10 ? "0" + horas : horas;
      var minutosFormatados = minutosRestantes < 10 ? "0" + minutosRestantes : minutosRestantes;

      return horasFormatadas + "h" + minutosFormatados + "min";
    },
    converterFormatohhHmmMinParaMinutos(formato) {
      // Extrair horas e minutos da string no formato "hhHmmmin"
      var horas = parseInt(formato.substring(0, 2), 10);
      var minutos = parseInt(formato.substring(3, 5), 10);

      // Calcular o total de minutos
      var totalMinutos = horas * 60 + minutos;
      return totalMinutos;
    },
  }
}
